import axios from "axios";

export default {
  namespaced: true,
  state: {
    lista: [],
    perPage: 100,
    textoPesquisa: '',
    situacao: null, // null = todos, '1' = ativo, '0' = inativo
    registroSelecionadoId: null,
    paginaAtual: 1,
    recarregarLista: false
  },
  getters: {
    LISTA: state => state.lista,
    PER_PAGE: state => state.perPage,
    TEXTO_PESQUISA: state => state.textoPesquisa,
    SITUACAO: state => state.situacao,
    REGISTRO_SELECIONADO_ID: state => state.registroSelecionadoId,
    PAGINA_ATUAL: state => state.paginaAtual,
    RECARREGAR_LISTA: state => state.recarregarLista
  },
  mutations: {
    SET_LISTA: (state, payload) => {
      state.lista = payload
    },
    SET_PER_PAGE: (state, payload) => {
      state.perPage = payload
    },
    SET_TEXTO_PESQUISA: (state, payload) => {
      state.textoPesquisa = payload
    },
    SET_SITUACAO: (state, payload) => {
      state.situacao = payload
    },
    SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
      state.registroSelecionadoId = payload
    },
    SET_PAGINA_ATUAL: (state, payload) => {
      state.paginaAtual = payload
    },
    SET_LIMPAR: (state) => {
      state.textoPesquisa = ''
      state.situacao = null
      state.paginaAtual = 1
    },
    SET_RECARREGAR_LISTA: (state, payload) => {
      state.recarregarLista = payload
    }
  },
  actions: {
    GET_LISTA: async (context) => {
      try {
        const params = {
          textoPesquisa: context.state.textoPesquisa,
          situacao: context.state.situacao
        }
        const { data } = await axios.get(`/api/protected/grupo-apagar/pesquisar`, { params })
        context.commit('SET_LISTA', data)
        return data
      } catch (error) {
        console.error('Erro ao buscar lista de Grupo a Pagar', error)
        throw error
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modulos/grupo-apagar-store.js